import { getMediaBaseUrl } from "../config/apiBase";

/**
 * Turn a relative media path from the API into an absolute URL.
 */
export function resolveMediaUrl(path) {
  if (!path) return "";
  const s = String(path).trim();
  if (!s) return "";
  if (/^https?:\/\//i.test(s)) return s;
  const base = getMediaBaseUrl();
  const normalized = s.startsWith("/") ? s : `/${s}`;
  return `${base}${normalized}`;
}
